export default __webpack_public_path__ + "static/es-49925d3c33e37d0942553c2119354f80.svg";